import React from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { DefaultCellRenderer } from '../../../../../containers/BulkSheetView/components/cellRenderer'
import CustomTooltip from './CustomTooltip'
import { featureFlagService } from '../../../../../../utils/feature-flag'
import {
  ActualWorkingHoursRow,
  formatTime,
  formatWorkTime,
  isWorkingDay,
  WorkingHoursType,
} from '../../../ActualWorkingHours'
import DateVO from '../../../../../../vo/DateVO'
import { intl } from '../../../../../../i18n'

const TotalActualHourCellRenderer: React.FC<ICellRendererParams> = props => {
  const getTooltipValue = (): string | undefined => {
    if (!featureFlagService.isEnabled('task-actual-work-application')) {
      return undefined
    }
    const data = props.data as ActualWorkingHoursRow
    if (!data || data.type !== 'WORK_HOUR') return undefined
    const formatTotalProjectHours = formatTime(
      data.projectHours?.reduce(
        (sum, project) => sum + (project.actualHour || 0),
        0
      ) || 0
    )
    const actualHour = formatWorkTime(data)
    const today = new DateVO().formatForApi()
    if (data.date && today && data.date <= today) {
      if (isWorkingDay(data.workingHoursType as WorkingHoursType)) {
        if (formatTotalProjectHours === '0:00' && actualHour === '') {
          return
        }
        if (formatTotalProjectHours !== actualHour) {
          return intl.formatMessage(
            {
              id: 'taskActualWork.tooltip.discrepancy.message',
            },
            {
              projectHours: formatTotalProjectHours,
              actualHours:
                actualHour ||
                intl.formatMessage({
                  id: 'taskActualWork.tooltip.notEntered',
                }),
            }
          )
        }
      }
    }
    return undefined
  }

  const tooltipValue = getTooltipValue()

  return (
    <CustomTooltip value={tooltipValue || ''}>
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <DefaultCellRenderer {...props} />
      </div>
    </CustomTooltip>
  )
}

export default TotalActualHourCellRenderer
